<div class="lm-facade-detail-wrapper">
<div class="lm-facade-detail-title">
    <h3 class="lm-bold lm-header-3">{{propertiesLabel}}</h3>
<!--    @switch (businessClassDetail.type) {-->
<!--        @case ('transaction') {-->
<!--            <svg soho-icon [icon]="'unorderedlist'" soho-tooltip [content]="transactionalLabel"/>-->
<!--        }@case ('columnar') {-->
<!--            <svg soho-icon [icon]="'database'" soho-tooltip [content]="columnarLabel"/>-->
<!--        }-->
<!--        @case ('analytic') {-->
<!--            <svg soho-icon [icon]="'line-chart'" soho-tooltip [content]="cubeLabel"/>-->
<!--        }-->
<!--    }-->
  </div>
  <div class="lm-facade-detail-content" [class.lm-facade-detail-loaded]="businessClassDetail">
    <soho-accordion [allowOnePane]="true" [displayChevron]="true">
      @if (businessClassDetail.type === 'transaction') {
          <soho-accordion-header id="fields">
              <a href="#">
                  <span>{{fieldsLabel}}</span>
              </a>
          </soho-accordion-header>
          <soho-accordion-pane class="lm-transaction-pane">
              <lm-facade-business-class-panel
                  [panelType]="'fields'"
                  [businessClassDetail]="businessClassDetail"
              ></lm-facade-business-class-panel>
          </soho-accordion-pane>
<!--          <soho-accordion-header id="conditions">-->
<!--              <a href="#">-->
<!--                  <span>{{conditionsLabel}}</span>-->
<!--              </a>-->
<!--          </soho-accordion-header>-->
<!--          <soho-accordion-pane class="lm-transaction-pane">-->
<!--              <lm-facade-business-class-panel-->
<!--                  [panelType]="'conditions'"-->
<!--                  [businessClassDetail]="businessClassDetail"-->
<!--              ></lm-facade-business-class-panel>-->
<!--          </soho-accordion-pane>-->
          <soho-accordion-header id="filters">
              <a href="#">
                  <span>{{filtersLabel}}</span>
              </a>
          </soho-accordion-header>
          <soho-accordion-pane class="lm-transaction-pane">
              <lm-facade-business-class-panel
                  [panelType]="'filters'"
                  [businessClassDetail]="businessClassDetail"
              ></lm-facade-business-class-panel>
          </soho-accordion-pane>
          <soho-accordion-header id="relations">
              <a href="#">
                  <span>{{relationsLabel}}</span>
              </a>
          </soho-accordion-header>
          <soho-accordion-pane class="lm-transaction-pane" >
              <lm-facade-business-class-panel
                  [panelType]="'relations'"
                  [businessClassDetail]="businessClassDetail"
              ></lm-facade-business-class-panel>
          </soho-accordion-pane>
          <soho-accordion-header id="sort-orders">
              <a href="#">
                  <span>{{sortsLabel}}</span>
              </a>
          </soho-accordion-header>
          <soho-accordion-pane class="lm-transaction-pane">
              <lm-facade-business-class-panel
                  [panelType]="'sort-orders'"
                  [businessClassDetail]="businessClassDetail"
              ></lm-facade-business-class-panel>
          </soho-accordion-pane>
      } @else if (businessClassDetail.type === 'columnar') {
          <soho-accordion-header id="columnar-fields">
              <a href="#">
                  <span>{{fieldsLabel}}</span>
              </a>
          </soho-accordion-header>
          <soho-accordion-pane class="lm-columnar-pane">
              <lm-facade-business-class-panel
                  [panelType]="'fields'"
                  [businessClassDetail]="businessClassDetail"
              ></lm-facade-business-class-panel>
          </soho-accordion-pane>
<!--          <soho-accordion-header id="columnar-conditions">-->
<!--              <a href="#">-->
<!--                  <span>{{conditionsLabel}}</span>-->
<!--              </a>-->
<!--          </soho-accordion-header>-->
<!--          <soho-accordion-pane class="lm-columnar-pane">-->
<!--              <lm-facade-business-class-panel-->
<!--                  [panelType]="'conditions'"-->
<!--                  [businessClassDetail]="businessClassDetail"-->
<!--              ></lm-facade-business-class-panel>-->
<!--          </soho-accordion-pane>-->
<!--          <soho-accordion-header id="columnar-dimensions">-->
<!--              <a href="#">-->
<!--                  <span>{{dimensionsLabel}}</span>-->
<!--              </a>-->
<!--          </soho-accordion-header>-->
<!--          <soho-accordion-pane class="lm-columnar-pane">-->
<!--              <lm-facade-business-class-panel-->
<!--                  [panelType]="'columnar-dimensions'"-->
<!--                  [businessClassDetail]="businessClassDetail"-->
<!--              ></lm-facade-business-class-panel>-->
<!--          </soho-accordion-pane>-->
<!--          <soho-accordion-header id="columnar-measures">-->
<!--              <a href="#">-->
<!--                  <span>{{measuresLabel}}</span>-->
<!--              </a>-->
<!--          </soho-accordion-header>-->
<!--          <soho-accordion-pane class="lm-columnar-pane">-->
<!--              <lm-facade-business-class-panel-->
<!--                  [panelType]="'columnar-measures'"-->
<!--                  [businessClassDetail]="businessClassDetail"-->
<!--              ></lm-facade-business-class-panel>-->
<!--          </soho-accordion-pane>-->
      } @else if (businessClassDetail.type === 'analytic') {
          <soho-accordion-header id="cube-dimensions">
              <a href="#">
                  <span>{{dimensionsLabel}}</span>
              </a>
          </soho-accordion-header>
          <soho-accordion-pane class="lm-analytic-pane">
              <lm-facade-business-class-panel
                  [panelType]="'cube-dimensions'"
                  [businessClassDetail]="businessClassDetail"
              ></lm-facade-business-class-panel>
          </soho-accordion-pane>
          <soho-accordion-header id="cube-measures">
              <a href="#">
                  <span>{{measuresLabel}}</span>
              </a>
          </soho-accordion-header>
          <soho-accordion-pane class="lm-analytic-pane">
              <lm-facade-business-class-panel
                  [panelType]="'cube-measures'"
                  [businessClassDetail]="businessClassDetail"
              ></lm-facade-business-class-panel>
          </soho-accordion-pane>
      }
    </soho-accordion>
  </div>
    <div class="lm-facade-detail-footer">
        <button soho-button="primary" (click)="onStartReportClicked()">{{startReportLabel}}</button>
    </div>
</div>
